// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__OLsz6","modalForm":"UpgradeEpcsModal_modalForm__c8i7J","modalFooter":"UpgradeEpcsModal_modalFooter__3asb3"};